import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
export const getSanitizedhighlightTextInput = (textToHighlight, textInput) => {
  const sanitizedTextInput = sanitize(textInput).replace(/^"|"$/g, '') // Removes surrounding quotes (")
  .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '\\$&'); // Removes all special characters;

  return textToHighlight.replace(new RegExp(`(${sanitizedTextInput})`, 'gi'), `<mark>$1</mark>`);
};